import React, { useState, useMemo } from "react";
import Button from "components/button/button";
import Input from "components/input/input";
import TextArea from "components/textarea/textarea";
import EnvelopIconSVG from "assets/svg/envelop-icon";
import PDFColoredIconSVG from "assets/svg/pdf-icon-colored";
import Divider from "components/divider/divider";
import DownloadSquareIconSVG from "assets/svg/download-square-icon";
import { copyTextToClipboard } from "utils/utils";
import CopyIconSVG from "assets/svg/copy-icon-svg";
import LoadingIndicator from "assets/svg/loading-indicator";
import toast from "react-hot-toast";
import PopInfo from "components/info-popup/pop-info";
import { useTranslation } from "react-i18next";


export default function ShareDownloadPanel({
  userData,
  id,
  isSubmit,
  onDone,
  onBack,
  template
}) {
  const { t } = useTranslation();
  const { http } = global.services;
  const [isCopied, setIsCopied] = useState(false);
  const [viewPDF, setViewPDF] = useState(false);
  const [downloadPDF, setDownload] = useState(false);
  const [state, setState] = useState({
    user_id: null,
    fileName: "",
    email: "",
    message: "",
    isSubmit: false,
  });
  // const link = `${process.env.REACT_APP_API_DOMAIN}/resume/${id}`;
  const link = `${process.env.REACT_APP_PUBLIC_DOMAIN}/preview/resume/${id}`;
  const download_link = `${process.env.REACT_APP_API_DOMAIN}/resume/${id}`;

  const htmlPDF = async()=>{
    const resumeElement = document.getElementById(template);
    await new Promise(requestAnimationFrame);
    await new Promise(resolve => setTimeout(resolve, 300));
    if (!resumeElement) {
        alert('Resume template not found.');
        setViewPDF(false);
        setState((prev) => ({ ...prev, isSubmit: false }));
        setDownload(false)
        return;
    }
  const styles = [...document.styleSheets]
    .map(sheet => {
        try {
            return [...sheet.cssRules]
                .map(rule => rule.cssText)
                .join('\n');
        } catch {
            return '';
        }
    }).join('\n');
  const html = `
      <!DOCTYPE html>
      <html>
          <head>
              <meta charset="UTF-8" />
              <style>
                  ${styles}
              </style>
          </head>
          <body>
              ${resumeElement.innerHTML}
          </body>
      </html>
    `;
  return html;
  }

  const handleCopyClick = (copyText) => {
    copyTextToClipboard(copyText)
      .then(() => {
        setIsCopied(true);
        setTimeout(() => {
          setIsCopied(false);
        }, 1500);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const download = async () => {
  try {
    setDownload(true)
    const html = await htmlPDF();

    const response = await http.post(
      `public/resumes/download-pdf`,
      { html },
      {
        responseType: 'blob'
      }
    );

    const url = window.URL.createObjectURL(
      new Blob([response.data], { type: 'application/pdf' })
    );

    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'resume.pdf');

    document.body.appendChild(link);
    link.click();
    link.remove();

    window.URL.revokeObjectURL(url);

    toast.success('Downloaded');
    setDownload(false)

  } catch (err) {
    console.log(err);
    toast.error('Download failed');
    setDownload(false)
  } finally {
    setState((prev) => ({ ...prev, isSubmit: false }));
  }
};

  const sendResume = async () => {
    setState((prev) => ({ ...prev, isSubmit: true }));
    try {
      const html = await htmlPDF();
      const { data } = await http.post(`public/resumes/${id}/mail`, {...state, html});
      toast.success(data.message);
    } catch (err) {
      toast.error(err.data?.message);
      console.log(err);
    } finally {
      setState((prev) => ({ ...prev, isSubmit: false }));
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setState((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  
 const pdfAttachmentHandle = async () => {
    try {
        setViewPDF(true)
        const html = await htmlPDF();
        const response = await http.post(
            'public/resumes/previewPDF',
            { html },
            {
                responseType: 'blob'
            }
        );

        const blob = new Blob([response.data], {
            type: 'application/pdf'
        });

        const url = window.URL.createObjectURL(blob);
        setViewPDF(false)
        window.open(url, '_blank');

        setTimeout(() => {
            URL.revokeObjectURL(url);
        }, 5000);

    } catch (error) {
        console.error(error);
        alert('Failed to generate PDF.');
        setViewPDF(false)
    }
};

  useMemo(() => {
    setState((prev) => ({
      ...prev,
      user_id: userData.user.id,
      fileName: `${userData.user.username} Resume.pdf`,
      email: userData.user.email,
      profile_id:userData.profile.id
    }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userData, id]);

  return (
    <div className="w-full h-full border-r border-resumeBorder">
      <div
        className="w-full overflow-y-auto overflow-x-hidden custom-scroll"
        style={{ height: "calc(100vh - 174px)" }}>
        <div className="w-full px-2 2sm:px-15.5 py-10.6">
          <div className="w-full flex flex-row gap-x-2 items-center">
            <h1 className="text-lightBlack text-xl font-semibold">
              {t('shareResume', 'Share Resume')}
            </h1>
            <PopInfo containerClass="relative" type="share_resume" />
          </div>
          <h2 className="text-lightBlack text-lg font-semibold mt-4">
            {t('emailResume')}
          </h2>
          <div className="w-full grid gap-4">
            <Input
              outsideLabel= {`${t('send')} ${t('to')}`}
              inputContainerClass="w-full"
              defaultValue={state.email}
              name="sendTo"
              placeholder="Send To"
              outsideLabelClass="text-sm font-bold text-darkerGray"
              noLabelPaddingY="1rem"
              type="text"
              onChange={handleInputChange}
            />
            <TextArea
              formContainer="w-full"
              label={t('message')}
              defaultValue={state.message}
              name="message"
              inputClass="p-4.5 text-base leading-6 text-lightBlack"
              rows={4}
              type="text"
              onChange={handleInputChange}
            />
            <div className="w-full grid grid-cols-1 2sm:grid-cols-2 gap-3">
              <Button
                iconPosition="left"
                disabled={viewPDF}
                // icon={<PDFColoredIconSVG />}
                buttonName={state.fileName}
                buttonTextClass="text-base leading-6 text-lightBlack flex justify-center gap-x-2.5 items-center"
                buttonRadius="6px"
                buttonClass="bg-thBg w-full py-4"
                onClick={pdfAttachmentHandle}
                icon={
                <div>
                  {viewPDF ? 
                    <LoadingIndicator className="text-primary w-5 h-5" />
                    :
                    <PDFColoredIconSVG />
                }
                </div>
              }/>
              <Button
                iconPosition="left"
                buttonName={t('sendResume')}
                disabled={state.isSubmit}
                buttonTextClass="text-base font-semibold text-white flex justify-center gap-x-2.5 items-center"
                buttonRadius="6px"
                buttonClass="bg-lightBlack w-full py-4"
                onClick={sendResume}
                icon={
                  state.isSubmit ? (
                    <LoadingIndicator className="text-white w-5 h-5" />
                  ) : (
                    <EnvelopIconSVG />
                  )
                }
              />
            </div>
          </div>
          <div className="w-full mt-9">
            <div className="w-full grid gap-y-12">
              <Divider text="or" />
              <div className="w-full">
                <div className="w-full">
                  <h1 className="text-lightBlack text-xl font-semibold">
                    {t('getResumeLink')}
                  </h1>
                  <p className="mt-2 text-darkerGray">
                    {t('shareYourResume')}
                  </p>
                </div>
                <div className="w-full mt-6">
                  <div className="flex flex-col 2sm:flex-row gap-2">
                    <Input
                      inputContainerClass="w-full"
                      defaultValue={link}
                      name="link"
                      placeholder={t("resumeLink")}
                      outsideLabelClass="text-sm font-bold text-darkerGray"
                      noLabelPaddingY="1rem"
                      type="text"
                      readOnly={true}
                    />
                    <Button
                      iconPosition="left"
                      icon={!isCopied ? <CopyIconSVG /> : null}
                      buttonName={isCopied ? t("copied") : t("copyLink")}
                      buttonTextClass="text-base font-semibold text-primary flex justify-center gap-x-2.5 items-center"
                      buttonRadius="6px"
                      buttonClass="bg-white border-2 border-primary w-full"
                      onClick={() => handleCopyClick(link)}
                    />
                  </div>
                </div>
              </div>
              <Divider text="or" />
              <div className="w-full grid gap-y-6">
                <h1 className="text-lightBlack text-md 2sm:text-xl font-semibold">
                  {t('downloadResume')}
                </h1>
                <Button
                  iconPosition="left"
                  buttonName={t("downloadPDF")}
                  buttonTextClass="text-md 2sm:text-base font-semibold text-lightBlack flex justify-center gap-x-2.5 items-center"
                  buttonRadius="6px"
                  buttonClass="bg-white border-2 border-lightBlack w-full py-5.4"
                  onClick={download}
                  disabled={downloadPDF}
                  icon={
                  downloadPDF ? (
                    <LoadingIndicator className="text-primary w-5 h-5" />
                  ) : (
                    <DownloadSquareIconSVG />
                  )
                }
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* footer */}
      <div className="w-full py-4 px-6 border-t border-resumeBorder">
        <div className="w-full flex justify-center 2sm:justify-end space-x-5">
          <Button
            disabled={isSubmit || state.isSubmit}
            buttonName={t("back")}
            buttonTextClass="text-sm font-semibold text-lightBlack"
            buttonRadius="6px"
            buttonClass="bg-thBg px-12 py-3 2sm:px-17.5 2sm:py-5"
            onClick={onBack}
          />
          <Button
            buttonName={t("done")}
            disabled={isSubmit || state.isSubmit}
            buttonTextClass="text-sm font-semibold text-white"
            buttonRadius="6px"
            buttonClass="relative bg-primary px-12 py-3 2sm:px-17.5 2sm:py-5"
            onClick={onDone}
            icon={
              <div className="absolute right-3 bottom-0 top-0 flex items-center">
                {isSubmit && (
                  <LoadingIndicator className="text-white w-5 h-5" />
                )}
              </div>
            }
          />
        </div>
      </div>
    </div>
  );
}
